import Logger from 'utils/logger';
import { Language, SUPPORTED_LANGUAGES } from '../constants';

export const normalizeLanguageCode = (code: string): string => {
  if (!code) return code;
  const parts = code.split('-');
  return parts[0].toLowerCase();
};

export const fetchAvailableLanguages = (): readonly string[] => {
  return SUPPORTED_LANGUAGES;
};

export const findMatchingLanguageCode = (
  requestedCode: string,
): Language | null => {
  const availableLanguages = SUPPORTED_LANGUAGES as readonly string[];

  if (availableLanguages.includes(requestedCode)) {
    return requestedCode as Language;
  }

  const normalizedRequested = normalizeLanguageCode(requestedCode);

  const exactMatch = availableLanguages.find(
    (code) => normalizeLanguageCode(code) === normalizedRequested,
  );

  if (exactMatch) {
    Logger.info('Mapped language code to available variant', {
      requested: requestedCode,
      matched: exactMatch,
    });
    return exactMatch as Language;
  }

  return null;
};

export const getLanguageDisplayName = (code: string): string => {
  const normalizedCode = normalizeLanguageCode(code);

  try {
    const nativeName = new Intl.DisplayNames([normalizedCode], {
      type: 'language',
    }).of(normalizedCode);

    if (nativeName)
      return nativeName.charAt(0).toUpperCase() + nativeName.slice(1);
  } catch {
    Logger.warn('Language name not found via Intl.DisplayNames', { code });
  }

  return code.toUpperCase();
};
